import {
  Dialog,
  DialogTitle,
  DialogContent,
  Box,
  Chip,
  Typography,
} from "@mui/material";

import { useEffect, useState } from "react";
import { useBszFinderContext } from "../../context/bszContext";
import bszService from "../../services";
import KsbDialogActions from "../../../../2_ksbHub/components/KsbDialogActions";
import { useAppContext } from "../../../../2_ksbHub/context/appContext";

export default function BszSubjectsDialog({ open, onClose }) {
  const { subjects, mySubjects, setMySubjects, loadRooms } =
    useBszFinderContext();
  const { isMobile } = useAppContext();

  const [selected, setSelected] = useState([]);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (open) {
      setSelected([...new Set(mySubjects.map((s) => s.id))]);
    }
  }, [open, mySubjects]);

  const toggle = (id) => {
    setSelected((prev) =>
      prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id],
    );
  };

  const handleSave = async () => {
    try {
      setSaving(true);
      await bszService.saveMySubjects(selected); //e.g. [7, 8, 9, 12, 11]

      /**
       * ✅ Update local state immediately
       */
      setMySubjects(subjects.filter((s) => selected.includes(s.id)));
      // e.g. [
      // { id: 7, name: "Deutsch" },
      // { id: 8, name: "Englisch" },
      // ]
      /**
       * ✅ Optional: refresh rooms so "Wer hilft" updates instantly
       */
      await loadRooms();

      /**
       * ✅ CLOSE DIALOG
       */
      onClose();
    } catch (err) {
      console.error("❌ saving subjects failed:", err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} fullWidth maxWidth="sm">
      <DialogTitle>
        {isMobile
          ? "Ich kann helfen in..."
          : "In welchen Fächern kannst du vermutlich Unterstützung anbieten?"}
        {!isMobile && (
          <Typography
            variant="caption"
            sx={{ display: "block", opacity: 0.7, mt: 0.5 }}
          >
            Sei grosszügig 😆
          </Typography>
        )}
      </DialogTitle>

      <DialogContent>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
          {[...subjects]
            .sort((a, b) => a.name.localeCompare(b.name, "de")) // ✅ sort alphabetically
            .map((s) => (
              <Chip
                key={s.id}
                label={s.name}
                clickable
                color={selected.includes(s.id) ? "primary" : "default"}
                onClick={() => toggle(s.id)}
              />
            ))}
        </Box>
      </DialogContent>

      <KsbDialogActions
        onCancel={onClose}
        onConfirm={handleSave}
        confirmLabel="Speichern"
        confirmDisabled={selected.length === 0 || saving}
        confirmLoading={saving}
      />
    </Dialog>
  );
}
